<template>
  <div class="station-header" :data-scrolled="isScrolled" :data-hide-stats="hideStats">
    <!-- 电站信息卡片 -->
    <div class="station-info">
      <!-- 上半部分：基本信息 -->
      <div class="station-basic">
        <!-- 电站图标 -->
        <div class="station-icon">
          <div class="station-point" :class="isOffline ? 'offline' : 'online'" v-tooltip="isOffline ? '离线' : '在线'">
          </div>
          <img :src="stationData.stationPicture || defaultStationImg" alt="电站图片">
        </div>

        <!-- 电站名称和信息 -->
        <div class="station-details">
          <!-- <StationSelector :currentStationId="stationData.id" @change="handleStationChange">
            <div class="station-name-row">
              <div class="station-name">{{ stationData.name }}</div>
              <div class="dropdown-icon">
                <img :src="require('@/assets/images/station-monitor/image_67.png')" />
              </div>
            </div>
          </StationSelector> -->

          <div class="station-name-row">
            <div class="station-name" v-tooltip:top="stationData.name">{{ stationData.name }}</div>
            <div class="dropdown-icon" @click="() => openStationSwitchDialog()" v-tooltip="'选择电站'">
              <!-- <img :src="require('@/assets/images/station-monitor/image_67.png')" /> -->
              <v-icon color="var(--color-primary)" size="18">
                <ArrowUpDown />
              </v-icon>
            </div>
          </div>

          <div class="station-meta">
            <span class="meta-item">{{ stationData.location }}</span>
            <span class="divider"></span>
            <span class="meta-item">{{ stationData.weather }}</span>
            <span class="divider"></span>
            <span class="meta-item">装机容量：{{ stationData.power + 'kW/' + stationData.capacity + 'kWh' }}</span>
          </div>
        </div>

        <!-- 下半部分：详细数据 -->
        <div class="station-stats">
          <!-- 实时功效 -->
          <div class="stat-item">
            <div class="stat-header">
              <span class="stat-label">总实时功率</span>
              <!-- <div class="stat-link">
                <span class="link-text">功率跟踪</span>
                <img :src="require('@/assets/images/station-monitor/image_69.png')" />
              </div> -->
            </div>
            <div class="stat-content">
              <div class="stat-value">
                <span class="value">{{ stationData.realTimePower }}</span>
                <span class="unit">kW</span>
              </div>
              <div ref="trendChartRef" class="trend-chart"></div>
              <GradientCircle :size="23" :strokeWidth="3" :gradientColors="['#DEF8B3', '#8DD3F5']"
                :progress="Number(stationData.realTimePower * 100 / stationData.power)" class="trend-icon" v-tooltip="`出力系数：${Number(stationData.realTimePower * 100 / stationData.power).toFixed(2)}%`" />
            </div>
          </div>

          <div class="stat-divider"></div>

          <!-- 电站SOC -->
          <div class="stat-item">
            <div class="stat-label">电站SOC</div>
            <div class="stat-content">
              <div class="stat-value">{{ (stationData.soc * 100).toFixed(2) }}%</div>
              <Battery :soc="stationData.soc * 100 " />
              <!-- <div class="progress-bar" style="transform: rotate(-90deg);">
                <div class="progress-fill" :style="{ width: stationData.soc * 100 + '%' }"></div>
              </div> -->
            </div>
          </div>

          <div class="stat-divider"></div>

          <!-- 能量链 -->
          <!-- <div class="stat-item">
            <div class="stat-label">能量链(在线/总数)</div>
            <div class="stat-content">
              <div class="stat-value">{{ stationData.energyChainOnline }}/{{ stationData.energyChainTotal }}</div>
              <div class="progress-bar">
                <div class="progress-fill"
                  :style="{ width: (stationData.energyChainTotal ? (stationData.energyChainOnline / stationData.energyChainTotal * 100) : 0) + '%' }">
                </div>
              </div>
            </div>
          </div> -->

          <!-- <div class="stat-divider"></div> -->

          <!-- 能量块 -->

          <div class="stat-item">
            <div class="stat-label">能量块(在线/总数)</div>
            <div class="stat-content">
              <div class="stat-value">{{ stationData.energyBlockOnline }}/{{ stationData.energyBlockTotal }}</div>
              <!-- <div class="progress-bar">
                <div class="progress-fill"
                  :style="{ width: (stationData.energyBlockTotal ? (stationData.energyBlockOnline / stationData.energyBlockTotal * 100) : 0) + '%' }">
                </div>
              </div> -->
            </div>
          </div>
        </div>

        <!-- 数据下载按钮 -->
        <v-btn class="download-btn" variant="text" @click="downloadDialog = true" v-tooltip="'数据下载'" rounded="pill">
          <img src="@/assets/images/station-monitor/image_68.png" class="download-icon" />
          <!-- <span class="download-text">数据下载&nbsp;</span> -->
        </v-btn>

      </div>


    </div>    

    <!-- 数据下载弹窗 -->
    <DataDownloadDialog v-model="downloadDialog" :isOldStation="!!baseData.isOldStation" />
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick, onUnmounted, inject } from 'vue'
import { initChart } from '@/utils/index'
import GradientCircle from '@/components/GradientCircle/index.vue'
import StationSelector from '@/components/StationSelector/index.vue'
import DataDownloadDialog from './DataDownloadDialog.vue'
import defaultStationImg from '@/views/home/components/StationList/defaultStation.png'
import { ArrowUpDown } from 'lucide-vue-next'
import Battery from './battery.vue'
// 接收滚动状态
const props = defineProps({
  isScrolled: {
    type: Boolean,
    default: false
  },
  baseData: {
    type: Object,
    default: () => ({})
  },
  realTimeData: {
    type: Object,
    default: () => ({})
  },
  powerTrackingData: {
    type: Array,
    default: () => []
  },
  hideStats: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['station-change'])

const openStationSwitch = inject('openStationSwitch', () => { })

function openStationSwitchDialog() {
  const tabKey = `stationTab`;
  const tab = sessionStorage.getItem(tabKey)
  openStationSwitch(tab)
}

const trendChartRef = ref(null)
let trendChartInstance = null

// 下载弹窗控制
const downloadDialog = ref(false)
const downloadForm = ref({
  deviceType: 'link',
  startDate: '2025-11-22 00:00:00',
  endDate: '2025-11-23 00:00:00',
  eLinkData: true
})

// const handleDownload = () => {
//   console.log('下载参数：', downloadForm.value)
//   downloadDialog.value = false
// }

// 电站信息数据
const stationData = computed(() => {
  const base = props.baseData || {}
  const rt = props.realTimeData || {}
  const weather = base.weather || {}

  return {
    id: base.id,
    name: base.name || '-',
    location: (base.province && base.city) ? `${base.province}-${base.city}` : '-',
    weather: (weather.day_air_temperature || weather.day_weather)
      ? `${weather.day_air_temperature ? weather.day_air_temperature + '℃' : ''} ${weather.day_weather ? weather.day_weather : ''}`
      : '-',
    capacity: base.capacity || rt.capacity || '-',
    power: base.power || base.max_power || rt.power || 0,
    realTimePower: rt.realTimePower || 0,
    soc: rt.soc || 0,
    energyChainOnline: rt.eLinkOnline || 0,
    energyChainTotal: rt.eLinkNumber || 0,
    energyBlockOnline: rt.eBlockOnline || 0,
    energyBlockTotal: rt.eBLockNumber || 0,
    stationPicture: base.station_picture,
    online: base.online
  }
})

const isOffline = computed(() => {
  return !stationData.value.online
})

// 初始化 mini 功率趋势图
const initTrendChart = (data) => {
  if (!trendChartRef.value) return

  // 处理数据
  const powerData = data && data.length > 0
    ? data.map(item => item.power || item.pcspower_dc || 0)
    : []

  const option = {
    grid: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    xAxis: {
      type: 'category',
      show: false,
      data: Array.from({ length: powerData.length }, (_, i) => i)
    },
    yAxis: {
      type: 'value',
      show: false
    },
    series: [
      {
        type: 'line',
        data: powerData,
        smooth: true,
        showSymbol: false,
        lineStyle: {
          color: '#39D8BB',
          width: 1.5
        },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(57, 216, 187, 0.3)' },
              { offset: 1, color: 'rgba(57, 216, 187, 0)' }
            ]
          }
        }
      }
    ]
  }

  trendChartInstance = initChart(trendChartRef.value, undefined, option)
}

const handleStationChange = (id) => {
  emit('station-change', id)
}

// 监听数据变化
watch(
  () => props.powerTrackingData,
  (newData) => {
    if (newData && newData.length > 0) {
      nextTick(() => {
        initTrendChart(newData)
      })
    } else {
      if (trendChartInstance) {
        trendChartInstance.clear()
      }
    }
  },
  { immediate: true, deep: true }
)

onUnmounted(() => {
  if (trendChartInstance) {
    trendChartInstance.dispose()
    trendChartInstance = null
  }
})
</script>

<style scoped lang="scss">
.station-header {
  flex: 1;
  min-width: 600px;
  /* 设置最小宽度，防止被压缩得太小 */
  margin-right: 16px;
  height: 196px;
  flex-shrink: 0;
  transition: all 0.3s ease;

  // 当隐藏统计信息时，调整高度
  &[data-hide-stats="true"] {
    height: 90px;

    .station-info {
      height: 90px;
    }
  }
}

.station-info {
  width: 100%;
  min-width: 100%;
  /* 确保背景也填满 */
  height: 196px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.63) 0%, rgba(255, 255, 255, 0.42) 100%);
  border-radius: 30px;
  border: 0.5px solid rgba(255, 255, 255, 1);
  backdrop-filter: blur(10px);
  overflow: hidden;
  transition: all 0.3s ease;
}

.station-basic {
  display: flex;
  align-items: center;
  padding: 17px 28px 21px;
  height: 90px;
}

.station-icon {
  width: 52px;
  height: 52px;
  background: #c0c3c6;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;

  >img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .station-point {
    position: absolute;
    top: 4px;
    left: 4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #000;
    border: 1px solid #fff;
    z-index: 1;

    &.online {
      background: #15FFAB;
    }

    &.offline {
      background: #FF8A67;
    }
  }
}

.station-details {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.station-name-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.station-name {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 24px;
  color: rgba(46, 46, 46, 1);
  font-weight: 500;
  line-height: normal;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-icon {
  margin-top: 8px;
  width: 11px;
  height: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    width: 9.63px;
    height: 6.19px;
  }
}

.station-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 12px;
  color: rgba(46, 46, 46, 0.7);
  font-weight: 300;
  line-height: normal;

  .divider {
    width: 1px;
    height: 9px;
    background: rgba(46, 46, 46, 0.16);
    border-radius: 6px;
  }
}

.download-btn {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;

  position: absolute;
  top: 28px;
  right: 8px;

  .download-icon {
    width: 16px;
    height: 16px;
  }

  .download-text {
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 14px;
    color: rgba(58, 104, 255, 1);
    text-align: right;
    font-weight: 400;
    line-height: normal;
  }
}

.station-stats {
  display: flex;
  align-items: flex-start;
  margin-left: 32px;
  padding: 25px 28px;
  // height: 106px;
  // background: rgba(255, 255, 255, 1);
  border-radius: 30px;
  transition: all 0.3s ease;
  overflow: hidden;
  flex-grow: 1;
  gap: 8px;
}

// 使用属性选择器来隐藏下半部分
.station-header[data-scrolled="true"] {
  height: 90px;

  .station-info {
    height: 90px;
  }

  .station-stats {
    padding: 0 28px;
    // height: 0;
    // opacity: 0;
  }
}

.stat-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &:first-child {
    flex-grow: 1.5;
  }
}

.stat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.stat-label {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
  color: rgba(46, 46, 46, 1);
  font-weight: 400;
  line-height: normal;
}

.stat-link {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  .link-text {
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 14px;
    color: rgba(58, 104, 255, 1);
    text-align: right;
    font-weight: 400;
    line-height: normal;
  }

  img {
    width: 10px;
    height: 10px;
  }
}

.stat-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 13px;
  position: relative;
}

.stat-value {
  font-family: 'Gotham', sans-serif;
  font-size: 24px;
  color: rgba(46, 46, 46, 1);
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  // position: absolute;
  // left: 0;

  .unit {
    font-weight: 325;
  }
}

.trend-chart {
  width: 102px;
  height: 21px;
}

.trend-icon {
  width: 23px;
  height: 23px;
}

.trend-icon {
  width: 23px;
  height: 23px;
}


.progress-bar {
  width: 100px;
  height: 8px;
  background: rgba(239, 244, 251, 1);
  border-radius: 20px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(270deg, rgba(141, 211, 245, 1) 5.97%, rgba(184, 229, 214, 1) 52.99%, rgba(222, 248, 179, 1) 100%);
  border-radius: 20px;
  transition: width 0.3s ease;
}

.stat-divider {
  width: 1px;
  height: 45px;
  background: rgba(0, 0, 0, 0.1);
  margin: 6px 20px 0;
  flex-shrink: 0;
}

// 下载弹窗样式
// 下载弹窗样式
.download-dialog-content {
  width: 800px;
  height: 544px;
  background: linear-gradient(180deg, rgba(248, 252, 255, 1) 0%, rgba(249, 250, 252, 1) 101.29%);
  border-radius: 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .dialog-header {
    height: 23px;
    margin-top: 28px;
    padding: 0 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .dialog-title {
      font-family: 'HarmonyOS Sans SC', sans-serif;
      font-size: 20px;
      color: rgba(0, 0, 0, 1);
      font-weight: 400;
    }

    .close-icon {
      cursor: pointer;
      font-size: 16px;
    }
  }

  .dialog-body {
    padding: 0 28px;
    margin-top: 28px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .form-section {
      width: 744px;
      height: 123px;
      background: rgba(255, 255, 255, 1);
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      &.small-section {
        height: 60px;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding-right: 20px;

        .section-label {
          margin-top: 0;
        }
      }

      .section-label {
        margin-top: 20px;
        margin-left: 20px;
        font-family: 'HarmonyOS Sans SC', sans-serif;
        font-size: 16px;
        color: rgba(46, 46, 46, 1);
        font-weight: 400;
      }

      .device-types {
        margin-top: 16px;
        margin-left: 20px;
        width: 704px;
        height: 48px;
        display: flex;
        gap: 10px;

        .type-btn {
          width: 228px;
          height: 48px;
          border-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: 'HarmonyOS Sans SC', sans-serif;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s;
          border: 1px solid rgba(224, 228, 231, 1);
          color: rgba(46, 46, 46, 1);
          background: transparent;

          &.active {
            background: rgba(58, 104, 255, 1);
            color: rgba(255, 255, 255, 1);
            font-weight: 500;
            border: none;
          }
        }
      }

      .date-range {
        margin-top: 16px;
        margin-left: 20px;
        width: 704px;
        height: 48px;
        display: flex;
        align-items: center;
        gap: 4px;

        .date-input {
          width: 340px;
          height: 48px;
          background: rgba(239, 244, 251, 0.7);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: 'HarmonyOS Sans SC', sans-serif;
          font-size: 16px;
          color: rgba(46, 46, 46, 1);
          cursor: pointer;
        }

        .range-separator {
          font-family: 'HarmonyOS Sans SC', sans-serif;
          font-size: 16px;
          color: rgba(46, 46, 46, 1);
          padding: 0 4px;
        }
      }

      .data-options {
        .custom-checkbox {
          display: flex;
          align-items: center;
          cursor: pointer;

          .checkbox-box {
            width: 18px;
            height: 18px;
            border-radius: 6px;
            background: rgba(58, 104, 255, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 11px;
            opacity: 0.5; // 未选中状态模拟

            &.checked {
              opacity: 1;
            }
          }

          .checkbox-label {
            font-family: 'HarmonyOS Sans SC', sans-serif;
            font-size: 16px;
            color: rgba(46, 46, 46, 1);
          }
        }
      }
    }
  }

  .dialog-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 800px;
    height: 96px;
    background: #fff;
    border-radius: 0 0 30px 30px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    padding-top: 20px;
    padding-right: 28px;

    .footer-btns {
      display: flex;
      gap: 20px;

      button {
        height: 48px;
        border-radius: 10px;
        font-family: 'HarmonyOS Sans SC', sans-serif;
        font-size: 16px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .cancel-btn {
        width: 120px;
        border: 1px solid rgba(224, 228, 231, 1);
        color: rgba(46, 46, 46, 1);
        background: transparent;
      }

      .confirm-btn {
        width: 180px;
        background: rgba(58, 104, 255, 1);
        color: rgba(255, 255, 255, 1);
        font-weight: 500;
        border: none;
      }
    }
  }
}
</style>
